module.exports = {
  proxyTarget: process.env.REACT_APP_PROXY_TARGET,
  reportURL: process.env.REACT_APP_REPORT_URL
};
